module.exports = __webpack_public_path__ + "media/classic-whistle.eaff996d.mp3";